export enum Language {
  Croatian = 'hr',
  English = 'en',
}
